import React from 'react';
import PropTypes from 'prop-types';
import { withI18n } from '../../../hocs';
import { ButtonStyled } from './styled';

const ActionButton = ({ onClick, label, isRed, padding }) => {
  return (
    <ButtonStyled padding={padding} redButton={isRed}>
      <div className="button-holder">
        <button
          className="chat-button ts ts-quick"
          onClick={onClick}
          type="button"
        >
          {label}
        </button>
      </div>
    </ButtonStyled>
  );
};

ActionButton.propTypes = {
  isRed: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  padding: PropTypes.number,
};

export default withI18n(ActionButton);
